// src/components/PostCard.jsx
import DOMPurify from 'dompurify'
import { Link } from 'react-router-dom'

const slugFromFilePath = (path) => path.split('/')[1]

const PostCard = ({
                      path,
                      content,
                      isExpanded = false,
                      pinned = false,
                      isSeparate = false,
                      onToggleExpand = () => {},
                  }) => {
    const renderFullContent = isSeparate || isExpanded

    return (
        <div className={`post post-card ${renderFullContent ? 'active' : ''}`} role="article">
            {content.meta && (
                <div className="post-meta">
                    <h2 className="post-title">
                        {pinned && <span className="pin-icon">📌</span>}
                        {content.meta.title}
                    </h2>
                    <p className="post-date">{new Date(content.meta.date).toLocaleDateString()}</p>
                    {Array.isArray(content.meta.tags) && (
                        <div className="post-tags">
                            {content.meta.tags.map((tag) => (
                                <span
                                    key={tag}
                                    className="tag-badge clickable"
                                    onClick={() => {
                                        const encoded = tag.toLowerCase().replace(/\s+/g, '+')
                                        window.location.hash = `#${encoded}`
                                        if (isSeparate) {
                                            window.location.href = `/blog#${encoded}`
                                        } else {
                                            window.location.hash = `#${encoded}`
                                        }
                                    }}
                                >
                                    #{tag}
                                </span>
                            ))}
                        </div>
                    )}
                </div>
            )}

            {/* Preview content */}
            <div
                className={`sanitized-content ${content.isExpandable && !renderFullContent ? 'preview-only' : ''}`}
                dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(content.preview),
                }}
            />

            {/* Full content only when expanded or on separate page */}
            {content.isExpandable && renderFullContent && (
                <div
                    className="sanitized-content hidden-content"
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(content.full),
                    }}
                />
            )}

            {/* Read more link - left aligned above footer */}
            {!isSeparate && content.isExpandable && !isExpanded && (
                <div className="read-more-wrapper">
          <span className="read-more-text" onClick={() => onToggleExpand(path)}>
            more...
          </span>
                </div>
            )}

            {/* Footer actions (right aligned) */}
            {!isSeparate && (
                <div className="post-footer-buttons">
                    <Link
                        to={`/blog/${slugFromFilePath(path)}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="open-link-text"
                    >
                        🔗 shareable version
                    </Link>
                </div>
            )}
        </div>
    )
}

export default PostCard
